<template>
    <v-content class="gb">
        <v-container class="fill-width" fluid>
            <v-row align="center" justify="center">
                <v-col cols="12" md="12" class>
                    <v-card :loading="status==='loading'" class="fill-width card-theme custom-container">
                        <v-row align="center">
                            <v-col cols="12">
                                <h2 class="azul f-30 header-space ml-1 medium-font title-custom">
                                    Frequently Asked Questions</h2>
                            </v-col>
                        </v-row>
                        <v-divider style="margin-left: 0px!important;"></v-divider>

                        <v-row align="center">
                            <v-col cols="12">
                                <p v-for="(item, index) in faqs" :key="index">
                                    <span style="padding-left: 15px; font-weight: bold">{{ item.question }}</span><br>
                                    <span style="padding-left: 15px">{{ item.answer }}</span>
                                </p>
                                <p v-for="(item, index) in faqs" :key="index">
                                    <span style="padding-left: 15px; font-weight: bold">{{ item.question }}</span><br>
                                    <span style="padding-left: 15px">{{ item.answer }}</span>
                                </p>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-content>
</template>
<script>
    import {mapState} from "vuex";

    export default {
        name: "FAQs",
        created() {
            this.$store.dispatch('Legal/get_faqs');
        },
        computed: {
            ...mapState({
                status: state => state.Legal.status,
                faqs: state => state.Legal.faqs,
            })
        },
        data: () => ({
            firstName: "",
            lastName: "",
            email: "",
            companyName: "",
            help: ""
        }),

        methods: {}
    };
</script>
<style scoped lang="scss">
    .custom-container {
        max-width: 1222px !important;
        min-height: 632px;
        top: 30px;
        margin-bottom: 50px !important;
        padding: 20px 62px 50px 62px;
    }
</style>